import React, { useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { Helmet } from "react-helmet";
import { FaRegEyeSlash } from "react-icons/fa";
import { FaRegEye } from "react-icons/fa6";
import toast from 'react-hot-toast'
import Formvalidators from './validators/Formvalidators'

export default function SignIn() {
  let [pstatus, setPstatus] = useState(false)

  let [show, setShow] = useState(false)
  let navigate = useNavigate()
  let [data, setData] = useState({
    username: "",
    password: ""
  })

  let [errorMessage, setErrorMessage] = useState({
    username: "Email Field Is Required",
    password: "Password Field Is Required "
  })
  // get input data
  const getInputData = (e) => {
    let { name, value } = e.target;

    setErrorMessage((old) => {
      return {
        ...old,
        [name]: Formvalidators(e)
      }
    })
    setData((old) => {
      return {
        ...old,
        [name]: value
      }
    })
    // (data);  

  }


  async function postData(e) {
    e.preventDefault()
    // (e);

    let error = Object.values(errorMessage).find((x) => x !== "")

    if (!error) {
      let res = await fetch("/api/user/signin", {
        method: "POST",
        headers: {
          "content-type": "application/json",
        },
        body: JSON.stringify(data)
      })
      res = await res.json()
      if (res.result === "Done") {
        localStorage.setItem("login", true)
        // localStorage.setItem("name",res.data.name)
        localStorage.setItem("userid", res.data._id)
        localStorage.setItem("role", res.data.role)
        localStorage.setItem("token", res.token)
        // localStorage.setItem("email",res.data.email) 
        if (res.data.role === "@u_%&@!==?*&@!") {
          navigate("/");
          toast.success("Login SuccessFully !");
          window.location.reload();
        } else {
          navigate("/my-account");
          window.location.reload();
        }

      }
      else {
        setShow(true)
        setErrorMessage((old) => {
          return {
            ...old,
            username: "Invalid Username Try Again ",
            password: "Invalid Password Try Again ",
          }
        })
      }
    }
    else {
      setShow(true)

    }
  }




  return (
    <>
      {/* <Navbar2/> */}
      <Helmet>
        <title>Login | V Hotel The Grand Shoba</title>
        <meta name="description" content="Login to your V Hotel The Grand Shoba account to manage your bookings, profile, and more." />
        <meta name="robots" content="noindex, nofollow" />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <meta name="robots" content="index, follow" />
        <link rel="canonical" href="https://www.vhotelthegrandshoba.com/signin" />

      </Helmet>
      <div className="container-fluid signIn ">
        <div className="row min-vh-140 ">

          {/* Left Panel */}
          <div className="col-12 col-md-6 d-flex flex-column justify-content-center align-items-center text-white left-panel py-5">
            <div className="signin-img">
              <img src="/images/login-img_.svg" loading='lazy' alt="vHotelThe_Grand_Shoba_login" title='Login Title' className="mb-4" />
            </div>

          </div>

          {/* Right Panel */}
          <div className="col-12 col-md-6 signin-right-panel  d-flex justify-content-center align-items-center py-5">
            <div className="w-75">
              <h5 className="mb-4">Login to Your Account</h5>
              <form onSubmit={postData}>
                <div className="mb-3">
                  <label>Email Address*</label>
                  <input type="text" name='username' onChange={getInputData} placeholder="Enter Your E-mail" className={`${show && errorMessage ? "border-danger" : ""}`} />
                  {show && errorMessage ? <p className='text-danger'>{errorMessage.username}</p> : ""}
                </div>
                <div className="mb-3">
                  <label>Password*</label>
                  <input type={`${pstatus ? "text" : "password"}`} name='password' onChange={getInputData} className={`${show && errorMessage ? "border-danger" : ""}`} placeholder="Enter Your Password" />
                  {show && errorMessage ? <p className='text-danger'>{errorMessage.password}</p> : ""}

                </div>

                <div className="sigin-button-main">
                  <div className="signin-button">
                    <button type="submit" className=" signin-btn w-100" >Login</button>
                  </div>

                  <div className="other-login">
                    <hr /><span>OR</span> <hr />

                  </div>

              
                  <span onClick={() => setPstatus(!pstatus)}>{pstatus ? <FaRegEye className='password-icon-login' /> : <FaRegEyeSlash className='password-icon-login' />}</span>


                  <p className="mt-3 text-center">
                    Don't have an account? <Link to="/signup">Click Here </Link>
                  </p>
                  <p className="mt-3 text-center">
                    Forget Your Password? <Link to="/forget1">Click Here</Link>
                  </p>
                </div>
              </form>
            </div>
          </div>

        </div>
      </div>
    </>
  )
}
